var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListCustomerTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3381_16919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3381_16919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V4.5C3 4.0875 3.14687 3.73438 3.44062 3.44063C3.73437 3.14688 4.0875 3 4.5 3H15.5051C15.61 3 15.7082 3.01389 15.7999 3.04167C15.8916 3.06944 15.9792 3.09722 16.0625 3.125L14.6875 4.5H4.5V15.5H15.5V10.6458L17 9.14583V15.5C17 15.9125 16.8531 16.2656 16.5594 16.5594C16.2656 16.8531 15.9125 17 15.5 17H4.5ZM10.0208 11.875L16.4375 5.47917C16.5903 5.32639 16.7652 5.25 16.9621 5.25C17.1591 5.25 17.3314 5.32639 17.4792 5.47917C17.6319 5.63194 17.7083 5.80903 17.7083 6.01042C17.7083 6.21181 17.6329 6.38816 17.482 6.53948L10.5597 13.4814C10.4088 13.6327 10.2326 13.7049 10.0312 13.6979C9.82986 13.691 9.65278 13.6111 9.5 13.4583L6.0366 9.99494C5.8872 9.84553 5.8125 9.67361 5.8125 9.47917C5.8125 9.28472 5.88889 9.11111 6.04167 8.95833C6.19444 8.80556 6.37153 8.72917 6.57292 8.72917C6.77431 8.72917 6.95039 8.80456 7.10117 8.95533L10.0208 11.875Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCustomerTask);
export default __webpack_public_path__ + "static/media/listCustomerTask.b216863541a7b3c0b3cf2ab27476c504.svg";
export { ForwardRef as ReactComponent };